import React from "react";
import { FinancialConnection } from "../../common/types/financialConnection";
import { isPlaidConnection } from "../../common/helpers/financialConnection";
import { BrokenFinancialConnectionLink } from "../financialAccount/BrokenFinancialConnectionLink";
import { BrokenPlaidConnectionLink } from "../plaid/BrokenPlaidConnectionLink";
import { PlaidAccountMetadata } from "../../common/helpers/plaid";
import { IntegrationAccount } from "../../common/types/integrationAccount";
import { IntegrationConnection } from "../../common/types/integrationConnection";
import { isIntegrationConnection } from "../../common/helpers/integrationConnection";
import { FixIntegrationConnection } from "../integrationConnection/FixIntegrationConnection";
import { AlertIcon } from "../../icons";

interface Props {
    connection: FinancialConnection | IntegrationConnection;
    integrationAccount: IntegrationAccount;
    balanceSyncedAt: Date | null;
}

export const BrokenConnectionLink: React.FC<Props> = ({
    connection,
    integrationAccount,
    balanceSyncedAt,
}) => {
    if (isIntegrationConnection(connection)) {
        return (
            <FixIntegrationConnection
                integrationConnection={connection}
                variant="link"
                size="sm"
            >
                <AlertIcon className="icon-color-red-500 mr-2" />
                <span className="broken-connection-link__content">
                    Fix connection
                </span>
            </FixIntegrationConnection>
        );
    }

    if (isPlaidConnection(connection)) {
        return (
            <BrokenPlaidConnectionLink
                connection={connection}
                churnedAccount={
                    integrationAccount.metadata?.[
                        PlaidAccountMetadata.ACCOUNT_CHURN
                    ]
                        ? integrationAccount
                        : undefined
                }
            />
        );
    }

    return (
        <BrokenFinancialConnectionLink
            connection={connection}
            balanceSyncedAt={balanceSyncedAt}
        />
    );
};
